export default "__VITE_ASSET__3401b6f3__"